/**
 * Vuex taking-list pagination rules.
 *
 * Page 1 must never be treated as warm cache: after checkout the new order
 * already exists, but bottom-tab 「我的訂單」 reused the in-memory first page
 * until a full remount (re-login). Later pages may still be skipped once loaded.
 */
function shouldSkipTakingPage({ page, loadedPage, fetching }) {
  if (fetching) {
    return true;
  }

  const requested = Number(page) || 1;
  if (requested <= 1) {
    return false;
  }

  return requested <= (Number(loadedPage) || 0);
}

function shouldResetTakingRecords(page) {
  return (Number(page) || 1) <= 1;
}

module.exports = {
  shouldSkipTakingPage,
  shouldResetTakingRecords,
};
